// src/pages/Achats/components/AchatsRevenueChart.jsx
import React from "react";
import { FaChartColumn } from "react-icons/fa6";
import { formatMoney } from "../achatsUtils";

export default function AchatsRevenueChart({ data = [] }) {
  const max = Math.max(...data.map((item) => Number(item.value) || 0), 1);
  const total = data.reduce((sum, item) => sum + Number(item.value || 0), 0);

  return (
    <section className="rounded-[28px] border border-slate-200 bg-white p-4 shadow-sm dark:border-slate-800 dark:bg-slate-900 sm:p-5">
      <div className="mb-5 flex flex-col gap-2 sm:flex-row sm:items-end sm:justify-between">
        <div>
          <div className="inline-flex items-center gap-2 rounded-full bg-violet-50 px-3 py-1 text-xs font-bold uppercase tracking-wide text-violet-700 dark:bg-violet-950/70 dark:text-violet-300">
            <FaChartColumn />
            Revenus
          </div>

          <h2 className="mt-2 text-xl font-bold text-slate-900 dark:text-white">
            Revenus sur 12 mois
          </h2>

          <p className="mt-1 text-sm text-slate-500 dark:text-slate-400">
            Le graphique respecte les filtres actuellement appliqués.
          </p>
        </div>

        <div className="rounded-2xl bg-slate-950 px-4 py-3 text-white dark:bg-white dark:text-slate-950">
          <div className="text-xs font-semibold uppercase tracking-wide opacity-60">
            Total période
          </div>
          <div className="text-xl font-bold">{formatMoney(total)}</div>
        </div>
      </div>

      <div className="h-56">
        <div className="flex h-44 items-end gap-2 rounded-[24px] border border-slate-100 bg-slate-50 p-3 dark:border-slate-800 dark:bg-slate-950/60">
          {data.map((item) => {
            const value = Number(item.value) || 0;
            const height = Math.max((value / max) * 100, value > 0 ? 5 : 0);

            return (
              <div
                key={item.key}
                className="group flex h-full flex-1 flex-col justify-end"
                title={`${item.label} — ${formatMoney(value)} — ${item.count} achat(s)`}
              >
                <div
                  className="relative w-full rounded-t-2xl bg-gradient-to-t from-indigo-600 via-violet-500 to-pink-400 shadow-sm transition group-hover:opacity-80"
                  style={{ height: `${height}%` }}
                >
                  <div className="pointer-events-none absolute -top-10 left-1/2 hidden -translate-x-1/2 rounded-xl bg-slate-950 px-2 py-1 text-xs font-bold text-white shadow-lg group-hover:block">
                    {formatMoney(value)}
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        <div
          className="mt-2 grid gap-2"
          style={{
            gridTemplateColumns: `repeat(${data.length || 1}, minmax(0, 1fr))`,
          }}
        >
          {data.map((item) => (
            <div
              key={item.key}
              className="truncate text-center text-[11px] font-semibold text-slate-500 dark:text-slate-400"
            >
              {item.label}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}